import React, { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory, useLocation } from "react-router";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function CrearPlantillaSimple() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    
    // Modo edición
    const [modoEdicion, setModoEdicion] = useState(false);
    const [plantillaId, setPlantillaId] = useState(null);
    
    // Datos de la plantilla
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    
    // Secciones y campos
    const [secciones, setSecciones] = useState([
        {
            id: 'seccion_1',
            titulo: 'Sección 1',
            campos: []
        }
    ]);
    
    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        // Validación de permisos híbrida
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(p => p.slug === 'administrarPlantillas');
        } else if (userdata.up && userdata.up.includes('administrarPlantillas')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }
        
        setHasPermission(true);
        cargarDatos(userdata);
        
        // Verificar si es modo edición
        const params = new URLSearchParams(location.search);
        const id = params.get('id');
        if (id) {
            setModoEdicion(true);
            setPlantillaId(id);
            cargarPlantilla(id);
        }
    }, [location]);
    
    const cargarDatos = (userdata) => {
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.error(error);
                setLoggedIn(true);
            });
    };
    
    const cargarPlantilla = (id) => {
        setLoading(true);
        
        axios.get(`/plantillas-historia-clinica/${id}`)
            .then(response => {
                const plantilla = response.data;
                setNombre(plantilla.nombre);
                setDescripcion(plantilla.descripcion || '');
                setEspecialidad(plantilla.especialidad || '');
                
                // Parsear estructura JSON
                const estructura = typeof plantilla.estructura_json === 'string' 
                    ? JSON.parse(plantilla.estructura_json) 
                    : plantilla.estructura_json;
                
                if (estructura.secciones) {
                    setSecciones(estructura.secciones);
                }
                
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                alert('Error al cargar plantilla');
                setLoading(false);
            });
    };
    
    // Agregar nueva sección
    const agregarSeccion = () => {
        const nuevaSeccion = {
            id: `seccion_${Date.now()}`,
            titulo: `Sección ${secciones.length + 1}`,
            campos: []
        };
        setSecciones([...secciones, nuevaSeccion]);
    };
    
    // Eliminar sección
    const eliminarSeccion = (index) => {
        if (secciones.length === 1) {
            alert('Debe haber al menos una sección');
            return;
        }
        const nuevasSecciones = secciones.filter((_, i) => i !== index);
        setSecciones(nuevasSecciones);
    };
    
    // Actualizar título de sección
    const actualizarTituloSeccion = (index, nuevoTitulo) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[index].titulo = nuevoTitulo;
        setSecciones(nuevasSecciones);
    };
    
    // Agregar campo a sección
    const agregarCampo = (seccionIndex) => {
        const nuevoCampo = {
            id: `campo_${Date.now()}`,
            label: 'Nuevo Campo',
            tipo: 'text',
            requerido: false,
            valor: ''
        };
        
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos.push(nuevoCampo);
        setSecciones(nuevasSecciones);
    };
    
    // Eliminar campo
    const eliminarCampo = (seccionIndex, campoIndex) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos = nuevasSecciones[seccionIndex].campos.filter((_, i) => i !== campoIndex);
        setSecciones(nuevasSecciones);
    };
    
    // Actualizar campo
    const actualizarCampo = (seccionIndex, campoIndex, propiedad, valor) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos[campoIndex][propiedad] = valor;
        setSecciones(nuevasSecciones);
    };
    
    // Guardar plantilla
    const guardarPlantilla = (e) => {
        e.preventDefault();
        
        // Validaciones
        if (!nombre.trim()) {
            alert('Por favor ingrese el nombre de la plantilla');
            return;
        }
        
        if (secciones.length === 0) {
            alert('Debe haber al menos una sección');
            return;
        }
        
        // Validar que cada sección tenga al menos un campo
        for (let i = 0; i < secciones.length; i++) {
            if (secciones[i].campos.length === 0) {
                alert(`La sección "${secciones[i].titulo}" debe tener al menos un campo`);
                return;
            }
        }
        
        setLoading(true);
        
        const estructuraJSON = {
            metadata: {
                tipo_plantilla: especialidad || 'general',
                version: '1.0'
            },
            secciones: secciones
        };
        
        const data = {
            nombre: nombre,
            descripcion: descripcion,
            especialidad: especialidad,
            estructura_json: JSON.stringify(estructuraJSON)
        };
        
        const request = modoEdicion
            ? axios.put(`/plantillas-historia-clinica/${plantillaId}`, data)
            : axios.post('/plantillas-historia-clinica', data);
        
        request
            .then(response => {
                setLoading(false);
                alert(modoEdicion ? 'Plantilla actualizada exitosamente' : 'Plantilla creada exitosamente');
                history.push('/plantillas-historia-clinica-json');
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
                alert('Error al guardar plantilla: ' + (error.response?.data?.message || 'Error desconocido'));
            });
    };
    
    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;
    
    return (
        <div className="hold-transition sidebar-mini">
            <div className="wrapper">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>
                                        <i className="fas fa-file-medical"></i> {modoEdicion ? 'Editar' : 'Crear'} Plantilla
                                    </h1>
                                </div>
                                <div className="col-sm-6">
                                    <button 
                                        className="btn btn-secondary float-right"
                                        onClick={() => history.push('/plantillas-historia-clinica-json')}
                                    >
                                        <i className="fas fa-arrow-left"></i> Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <form onSubmit={guardarPlantilla}>
                                {/* Información básica */}
                                <div className="card">
                                    <div className="card-header bg">
                                        <h3 className="card-title">Información Básica</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Nombre de la Plantilla *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={nombre}
                                                        onChange={(e) => setNombre(e.target.value)}
                                                        placeholder="Ej: Medicina General, Odontología, etc."
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Especialidad</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={especialidad}
                                                        onChange={(e) => setEspecialidad(e.target.value)}
                                                        placeholder="Ej: Medicina General, Odontología"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={descripcion}
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Descripción opcional de la plantilla"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Secciones */}
                                {secciones.map((seccion, seccionIndex) => (
                                    <div key={seccionIndex} className="card">
                                        <div className="card-header bg">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={seccion.titulo}
                                                        onChange={(e) => actualizarTituloSeccion(seccionIndex, e.target.value)}
                                                        placeholder="Título de la sección"
                                                    />
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-info mr-2"
                                                        onClick={() => agregarCampo(seccionIndex)}
                                                    >
                                                        <i className="fas fa-plus"></i> Agregar Campo
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => eliminarSeccion(seccionIndex)}
                                                    >
                                                        <i className="fas fa-trash"></i> Eliminar Sección
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {seccion.campos.length === 0 && (
                                                <div className="alert alert-info">
                                                    <i className="fas fa-info-circle"></i> No hay campos en esta sección. 
                                                    Haga clic en "Agregar Campo" para añadir uno.
                                                </div>
                                            )}
                                            
                                            {seccion.campos.map((campo, campoIndex) => (
                                                <div key={campoIndex} className="card mb-2">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Etiqueta del Campo</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={campo.label}
                                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'label', e.target.value)}
                                                                        placeholder="Ej: Motivo de Consulta"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Tipo de Campo</label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={campo.tipo}
                                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'tipo', e.target.value)}
                                                                    >
                                                                        <option value="text">Texto</option>
                                                                        <option value="textarea">Texto Largo</option>
                                                                        <option value="select">Lista Desplegable</option>
                                                                        <option value="number">Número</option>
                                                                        <option value="checkbox">Casilla</option>
                                                                        <option value="date">Fecha</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Opciones</label>
                                                                    <div className="form-check">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            checked={campo.requerido || false}
                                                                            onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'requerido', e.target.checked)}
                                                                            id={`req_${seccionIndex}_${campoIndex}`}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`req_${seccionIndex}_${campoIndex}`}>
                                                                            Requerido
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2 text-right">
                                                                <label>&nbsp;</label>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger btn-block"
                                                                    onClick={() => eliminarCampo(seccionIndex, campoIndex)}
                                                                >
                                                                    <i className="fas fa-trash"></i> Eliminar
                                                                </button>
                                                            </div>
                                                        </div>
                                                        
                                                        {/* Opciones para select */}
                                                        {campo.tipo === 'select' && (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label>Opciones (separadas por coma)</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue={campo.opciones ? campo.opciones.join(', ') : ''}
                                                                            onBlur={(e) => {
                                                                                const opciones = e.target.value.split(',').map(o => o.trim()).filter(o => o);
                                                                                actualizarCampo(seccionIndex, campoIndex, 'opciones', opciones);
                                                                            }}
                                                                            placeholder="Ej: Si, No, No Aplica"
                                                                        />
                                                                        <small className="form-text text-muted">
                                                                            Separe las opciones con comas. Ejemplo: Opción 1, Opción 2, Opción 3
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                                {/* Botón agregar sección */}
                                <div className="text-center mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={agregarSeccion}
                                    >
                                        <i className="fas fa-plus"></i> Agregar Nueva Sección
                                    </button>
                                </div>

                                {/* Botones de acción */}
                                <div className="card">
                                    <div className="card-body text-center">
                                        <button
                                            type="button"
                                            className="btn btn-secondary mr-2"
                                            onClick={() => history.push('/plantillas-historia-clinica-json')}
                                        >
                                            <i className="fas fa-times"></i> Cancelar
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i> Guardando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-save"></i> {modoEdicion ? 'Actualizar' : 'Guardar'} Plantilla
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
                
                <Footer />
            </div>
        </div>
    );
}

export default CrearPlantillaSimple;
